module.exports = __webpack_public_path__ + "static/media/34DSS10.c509221d.jpg";